// extracted by mini-css-extract-plugin
export var btn = "styles-module--btn--9aa57";
export var btnLink = "styles-module--btn-link--64bdb";
export var dot = "styles-module--dot--e478e";
export var githubCount = "styles-module--github-count--21a24";
export var spacer = "styles-module--spacer--af55d";
export var star = "styles-module--star--f205c";
export var widget = "styles-module--widget--bb325";